import WeddingCourseV2Landing from './WeddingCourseV2Landing'

// Дубликат свадебного курса по пути /weddingcourse: информационный лендинг
// без блока стоимости и кнопок покупки. Оригинал /wc не затрагивается.
const WeddingCourseV2Page = () => {
  return (
    <div className="course-detail-page safe-area-inset">
      <WeddingCourseV2Landing />
    </div>
  )
}

export default WeddingCourseV2Page
